import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderCargoTaxiDraftResponseDataStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsOrderCargoTaxiDraftResponseDataContractCargoCompany = {
  companyName: string;
  displayName: string;
};

export enum BillingsOrderCargoTaxiDraftResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderCargoTaxiDraftResponseDataContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeDuringRide: boolean;
  allowChargeWhileReturning: boolean;
  discountLimit: number;
  cargoCompany: BillingsOrderCargoTaxiDraftResponseDataContractCargoCompany;
  model: BillingsOrderCargoTaxiDraftResponseDataContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsOrderCargoTaxiDraftResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsOrderCargoTaxiDraftResponseDataBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiDraftResponseDataBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAYS",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionBaseAmount =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.BASE_AMOUNT;
    comment?: string;
    distance: number;
    rate: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHighways =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CHARGE_HIGHWAYS;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHaltings =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountBeingLate =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOther =
  {
    type: BillingsOrderCargoTaxiDraftResponseDataBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiDraftResponseDataBillingContribution =
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionBaseAmount
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHighways
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiDraftResponseDataBillingContributionDiscountOther;

export type BillingsOrderCargoTaxiDraftResponseData = {
  status: BillingsOrderCargoTaxiDraftResponseDataStatus;
  passengers: string[];
  contract: BillingsOrderCargoTaxiDraftResponseDataContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  planEntryId: string;
  cargoOrder: BillingsOrderCargoTaxiDraftResponseDataCargoOrder;
  billingNodes: BillingsOrderCargoTaxiDraftResponseDataBillingNode[];
  billingContributions: BillingsOrderCargoTaxiDraftResponseDataBillingContribution[];
};

type BillingsOrderCargoTaxiDraftResponse =
  HttpResponse<BillingsOrderCargoTaxiDraftResponseData>;

export default BillingsOrderCargoTaxiDraftResponse;
